import { heroData } from '@/mocks/homeData';

export default function Hero() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-gradient-to-br from-background-100 via-background-50 to-primary-50/40"
    >
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-200/20 blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full bg-accent-200/15 blur-3xl"></div>
        <div className="absolute top-1/2 left-1/3 w-[400px] h-[400px] rounded-full bg-secondary-200/15 blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-5 whitespace-nowrap">
              {heroData.tag}
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-950 leading-tight mb-4">
              {heroData.siteName}
              <span className="block text-2xl md:text-3xl lg:text-4xl text-foreground-700 mt-1">{heroData.positioning}</span>
            </h1>

            <p className="text-base font-medium text-primary-600 mb-6">{heroData.slogan}</p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              {heroData.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-primary-600 font-heading">{stat.value}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={heroData.primaryCta.href}
                onClick={(e) => handleClick(e, heroData.primaryCta.href)}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                {heroData.primaryCta.label}
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href={heroData.secondaryCta.href}
                onClick={(e) => handleClick(e, heroData.secondaryCta.href)}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50 hover:bg-background-100 text-foreground-700 font-medium text-sm rounded-lg border border-background-300 transition-colors whitespace-nowrap cursor-pointer"
              >
                {heroData.secondaryCta.label}
                <i className="ri-arrow-down-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20entertainment%20atmosphere%20with%20warm%20peach%20and%20coral%20gradient%20lighting%2C%20abstract%20film%20elements%20floating%20in%20dramatic%20composition%2C%20luxurious%20dark%20background%20with%20golden%20light%20streaks%2C%20movie%20theater%20aesthetic%2C%20rich%20warm%20tones%2C%20high%20end%20visual%20with%20soft%20bokeh&width=1000&height=750&seq=hero-main-visual&orientation=landscape"
                alt="桃子视频 - 高清影视聚合平台主视觉"
                className="w-full h-full object-cover rounded-xl"
                title="桃子视频 - 数字系列视频聚合平台"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/30 via-transparent to-transparent rounded-xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}